// Mock data for Trademark Brand Logo website

export const businessInfo = {
  name: "Trademark Brand Logo",
  email: "Info@trademarkbrandlogo.com",
  phone: "+1 (123) 123-4567",
  address: "10815 Rancho Bernardo Rd #300, San Diego, CA 92127"
};

export const heroData = {
  title: "Protect Your Brand with Expert Trademark Registration Services",
  subtitle: "USPTO Filing Experts | Fast, Affordable, and Reliable Trademark Protection",
  description: "Secure your business identity with our comprehensive trademark registration services. We handle everything from trademark search to federal filing, ensuring your brand is legally protected across the United States.",
  ctaText: "Register My Trademark",
  secondaryCtaText: "Chat Now",
  image: "https://images.pexels.com/photos/6077123/pexels-photo-6077123.jpeg",
  stats: [
    { number: "15,000+", label: "Trademarks Filed" },
    { number: "98%", label: "Success Rate" },
    { number: "50+", label: "States Served" }
  ]
};

export const aboutData = {
  title: "About Trademark Brand Logo",
  subtitle: "Your Trusted Partner in Intellectual Property Protection",
  description: "With over a decade of experience in trademark and intellectual property law, Trademark Brand Logo has become a leading name in brand protection services across the United States. Our team of experienced trademark attorneys and IP specialists work tirelessly to ensure your business identity remains secure and legally protected.",
  content: "We understand that your brand is more than just a name or logo – it's your business's identity, reputation, and future. That's why we've developed a streamlined, efficient process that makes trademark registration accessible and affordable for businesses of all sizes. From startups to established corporations, we've helped thousands of clients protect their most valuable assets.",
  features: [
    "Licensed USPTO Trademark Attorneys",
    "Comprehensive Trademark Search",
    "Fast-Track Filing Options",
    "Ongoing Trademark Monitoring",
    "100% Satisfaction Guarantee"
  ],
  image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2"
};

export const servicesData = [
  {
    id: "trademark-registration",
    title: "Trademark Registration Services",
    icon: "Scale",
    shortDescription: "Comprehensive trademark registration services to protect your brand name, logo, and business identity at the federal level.",
    description: "Our trademark registration services provide complete protection for your brand identity. We handle the entire process from initial trademark search to final USPTO approval, ensuring your brand receives maximum legal protection.",
    features: [
      "Complete USPTO trademark filing",
      "Comprehensive trademark search",
      "Office action responses",
      "Trademark monitoring services",
      "Dedicated case manager"
    ],
    image: "https://images.pexels.com/photos/5668806/pexels-photo-5668806.jpeg",
    keywords: ["us trademark registration", "trademark services", "federal trademark registration", "register a trademark"]
  },
  {
    id: "copyright-registration",
    title: "Copyright Registration Services",
    icon: "FileText",
    shortDescription: "Register and protect your original creative works, including literary works, software, music, and artistic creations.",
    description: "Protect your creative works with our comprehensive copyright registration services. Whether you're an author, artist, musician, or software developer, we ensure your intellectual property receives proper legal protection.",
    features: [
      "US Copyright Office filing",
      "All work types covered",
      "Fast processing times",
      "Certificate of registration",
      "Infringement protection"
    ],
    image: "https://images.unsplash.com/photo-1593444285553-28163240e3f1",
    keywords: ["us copyright registration", "register copyright", "online copyright registration", "file copyright"]
  },
  {
    id: "company-formation",
    title: "Company Formation",
    icon: "Building",
    shortDescription: "Complete business formation services including LLC, Corporation, and DBA registration in all 50 states.",
    description: "Start your business the right way with our comprehensive company formation services. We handle all the paperwork and legal requirements to get your business up and running quickly and efficiently.",
    features: [
      "LLC and Corporation formation",
      "DBA registration",
      "EIN acquisition",
      "Operating agreements",
      "All 50 states covered"
    ],
    image: "https://images.pexels.com/photos/8373815/pexels-photo-8373815.jpeg",
    keywords: ["start llc", "start a business", "register business name", "register a company"]
  },
  {
    id: "trademark-search",
    title: "Trademark Search",
    icon: "Search",
    shortDescription: "Comprehensive trademark search services to identify potential conflicts before filing your trademark application.",
    description: "Avoid costly rejections and legal disputes with our thorough trademark search services. We search federal, state, and common law databases to identify potential conflicts with your proposed trademark.",
    features: [
      "Federal database search",
      "State trademark search",
      "Common law search",
      "Detailed conflict analysis",
      "Risk assessment report"
    ],
    image: "https://images.unsplash.com/photo-1516382799247-87df95d790b7",
    keywords: ["uspto trademark search", "trademark search services", "trademark search", "trademark name search"]
  },
  {
    id: "amazon-brand-registry",
    title: "Amazon Brand Registry",
    icon: "ShoppingCart",
    shortDescription: "Enroll your brand in Amazon Brand Registry to protect your products and gain enhanced selling tools on Amazon.",
    description: "Maximize your Amazon selling potential with our Amazon Brand Registry services. We help you enroll your registered trademark in Amazon's Brand Registry program, giving you enhanced brand protection and marketing tools.",
    features: [
      "Trademark filing for Amazon",
      "Brand Registry enrollment",
      "Enhanced content access",
      "Brand protection tools",
      "A+ content capabilities"
    ],
    image: "https://images.pexels.com/photos/4144768/pexels-photo-4144768.jpeg",
    keywords: ["register brand on amazon", "enroll in amazon brand registry", "brand registry amazon", "amazon seller trademark"]
  }
];

export const whyChooseUsData = {
  title: "Why Choose Trademark Brand Logo",
  subtitle: "Experience the Difference of Working with True Trademark Professionals",
  reasons: [
    {
      title: "USPTO Registered Attorneys",
      description: "Our team consists of licensed attorneys registered with the United States Patent and Trademark Office, ensuring expert handling of your trademark application.",
      icon: "Award"
    },
    {
      title: "Proven Track Record",
      description: "With over 15,000 successful trademark registrations and a 98% approval rate, we have the experience and expertise to protect your brand effectively.",
      icon: "TrendingUp"
    },
    {
      title: "Affordable Pricing",
      description: "We believe brand protection should be accessible to all businesses. Our transparent pricing and flexible packages ensure you get the best value for your investment.",
      icon: "DollarSign"
    },
    {
      title: "Comprehensive Search",
      description: "Our thorough trademark search process examines federal, state, and common law databases to identify potential conflicts before filing, saving you time and money.",
      icon: "Search"
    },
    {
      title: "Dedicated Support",
      description: "Each client is assigned a dedicated case manager who guides you through every step of the trademark process, ensuring clear communication and peace of mind.",
      icon: "Headphones"
    },
    {
      title: "Fast Processing",
      description: "We understand the importance of speed in business. Our streamlined process ensures your trademark application is filed quickly and accurately, minimizing delays.",
      icon: "Zap"
    }
  ]
};

export const processSteps = [
  {
    step: 1,
    title: "Search & Consultation",
    description: "We conduct a comprehensive trademark search and provide expert consultation on your trademark's registrability and protection strategy."
  },
  {
    step: 2,
    title: "Filing & Documentation",
    description: "Our team prepares and files your complete trademark application with the USPTO, ensuring all documentation meets legal requirements."
  },
  {
    step: 3,
    title: "Monitoring & Approval",
    description: "We monitor your application status, respond to any office actions, and secure your final trademark registration certificate."
  }
];

export const pricingPlans = [
  {
    name: "Essentials",
    price: "$45",
    fee: "+ Federal Filing Fee",
    note: "(Govt. filing fee not included)",
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    popular: false
  },
  {
    name: "Enhanced",
    price: "$149",
    fee: "+ Federal Filing Fee",
    note: "(Govt. filing fee not included)",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    popular: false
  },
  {
    name: "Deluxe",
    price: "$299",
    fee: "+ Federal Filing Fee",
    note: "(Govt. filing fee not included)",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    popular: true,
    recommended: true
  },
  {
    name: "Platinum",
    price: "$349",
    fee: "+ Federal Filing Fee",
    note: "(Govt. filing fee not included)",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    popular: false
  }
];

export const industriesServed = [
  {
    title: "Technology & Software",
    description: "Protecting innovative software products, mobile apps, SaaS platforms, and tech startups with comprehensive trademark and copyright registration services.",
    icon: "Laptop"
  },
  {
    title: "E-commerce & Retail",
    description: "Safeguarding online and brick-and-mortar retail brands, product lines, and e-commerce businesses with trademark registration and Amazon Brand Registry services.",
    icon: "ShoppingBag"
  },
  {
    title: "Healthcare & Medical",
    description: "Securing medical practices, pharmaceutical brands, healthcare services, and wellness products with specialized trademark protection strategies.",
    icon: "Heart"
  },
  {
    title: "Food & Beverage",
    description: "Protecting restaurant brands, food products, beverage companies, and culinary innovations with trademark and recipe copyright services.",
    icon: "Coffee"
  },
  {
    title: "Fashion & Apparel",
    description: "Defending clothing brands, fashion labels, jewelry lines, and design innovations with trademark registration and design patent services.",
    icon: "Shirt"
  },
  {
    title: "Entertainment & Media",
    description: "Protecting production companies, content creators, music labels, and entertainment brands with comprehensive IP protection services.",
    icon: "Film"
  }
];

export const trustSignals = {
  title: "Trusted by Thousands of Businesses",
  subtitle: "Join the growing community of businesses that trust us to protect their most valuable assets",
  stats: [
    { value: "15,000+", label: "Trademarks Filed Successfully" },
    { value: "98%", label: "USPTO Approval Rate" },
    { value: "10+", label: "Years of Experience" },
    { value: "50", label: "States Served" }
  ],
  testimonials: [
    {
      name: "David Thompson",
      business: "CloudTech Innovations",
      rating: 5,
      text: "The team at Trademark Brand Logo made the entire trademark registration process seamless and stress-free. Their expertise and attention to detail gave me complete confidence in protecting my brand."
    },
    {
      name: "Priya Patel",
      business: "Wellness & Beyond Spa",
      rating: 5,
      text: "Outstanding service from start to finish! They conducted a thorough search, filed everything correctly, and kept me informed throughout the entire process. Highly recommended!"
    },
    {
      name: "Marcus Williams",
      business: "Urban Brew Coffee Co.",
      rating: 5,
      text: "Professional, knowledgeable, and incredibly responsive. They helped me secure trademark protection for my coffee brand and even assisted with Amazon Brand Registry. Worth every penny!"
    },
    {
      name: "Jennifer Martinez",
      business: "Bella Vita Boutique",
      rating: 5,
      text: "I was worried about the complexity of trademark registration, but this team made it so easy! They handled everything professionally and got my trademark approved on the first try. Couldn't be happier!"
    },
    {
      name: "Robert Chang",
      business: "Digital Marketing Pros",
      rating: 5,
      text: "Fast, efficient, and extremely knowledgeable. They not only registered my trademark but also provided valuable advice on protecting my brand long-term. The best investment I've made for my business!"
    },
    {
      name: "Amanda Foster",
      business: "Green Earth Organics",
      rating: 5,
      text: "The comprehensive trademark search they performed saved me from potential legal issues. Their attention to detail and commitment to client success is unmatched. I've already referred three colleagues!"
    },
    {
      name: "James Anderson",
      business: "Anderson & Associates Law Firm",
      rating: 5,
      text: "As an attorney myself, I appreciate quality legal work. Their trademark services exceeded my expectations. Professional, thorough, and remarkably efficient. They've earned my complete trust and future business."
    },
    {
      name: "Sofia Hernandez",
      business: "Luxe Beauty Products",
      rating: 5,
      text: "From the initial consultation to final registration, the experience was flawless. They answered all my questions promptly and made me feel like a priority. My brand is now fully protected thanks to their expertise!"
    },
    {
      name: "Kevin O'Brien",
      business: "FitLife Nutrition",
      rating: 5,
      text: "I tried to file my trademark myself and got rejected. These experts took over, fixed the issues, and got my trademark approved within months. Their knowledge of USPTO requirements is exceptional!"
    }
  ]
};

export const faqData = [
  {
    question: "What is a trademark and why do I need one?",
    answer: "A trademark is a legal protection for your brand name, logo, slogan, or other identifying marks that distinguish your products or services from competitors. Registering a trademark gives you exclusive rights to use that mark in commerce and provides legal recourse against infringement. It's essential for protecting your brand identity, building consumer trust, and preventing others from using confusingly similar marks that could damage your business reputation."
  },
  {
    question: "How long does the trademark registration process take?",
    answer: "The complete trademark registration process typically takes 8-12 months from filing to final approval by the USPTO. This timeline includes the initial filing, examination by a USPTO attorney, publication for opposition, and final registration. However, this can vary based on the complexity of your mark, any office actions that need to be addressed, and current USPTO processing times. We monitor your application throughout the entire process and handle any issues that arise to ensure the smoothest possible path to registration."
  },
  {
    question: "What's the difference between state and federal trademark registration?",
    answer: "State trademark registration provides protection only within that specific state's borders, while federal trademark registration through the USPTO provides nationwide protection and exclusive rights to use the mark in interstate commerce. Federal registration also offers additional benefits including legal presumption of ownership, the right to use the ® symbol, access to federal courts for infringement cases, and the ability to register your trademark internationally. For most businesses, federal registration provides significantly stronger and broader protection."
  },
  {
    question: "Can I trademark a name that's similar to an existing trademark?",
    answer: "It depends on several factors including the similarity of the marks, the relatedness of the goods or services, and the strength of the existing trademark. Our comprehensive trademark search examines federal, state, and common law databases to identify potential conflicts. We then provide a detailed risk assessment and recommendations. In some cases, marks can coexist if they're in different industries or geographic areas, but attempting to register a confusingly similar mark in the same industry will likely result in rejection or legal challenges."
  },
  {
    question: "What is included in your trademark search?",
    answer: "Our comprehensive trademark search includes examination of the USPTO federal trademark database, state trademark registries across all 50 states, common law trademark usage (unregistered marks in use), domain name registrations, business name databases, and social media platforms. We analyze all findings to identify potential conflicts and provide you with a detailed report including risk assessment, similarity analysis, and recommendations for proceeding with your trademark application. This thorough search helps avoid costly rejections and legal disputes."
  },
  {
    question: "What happens if my trademark application is rejected?",
    answer: "If the USPTO issues an office action (rejection or request for clarification), our experienced trademark attorneys will review the issues raised and prepare a comprehensive response. Most office actions can be successfully overcome with proper legal arguments and evidence. We handle all communication with the USPTO and work diligently to address any concerns raised by the examining attorney. Our service includes responding to office actions, and our high success rate demonstrates our expertise in navigating the trademark registration process."
  },
  {
    question: "Do I need a trademark attorney to register my trademark?",
    answer: "While it's legally possible to file a trademark application yourself, working with a trademark attorney significantly increases your chances of success. Trademark law is complex, and small mistakes in the application can result in delays, rejections, or inadequate protection. Our USPTO-registered attorneys ensure your application is properly prepared, your mark is adequately protected, potential conflicts are identified before filing, and any office actions are professionally addressed. The investment in professional trademark services often saves money by avoiding costly mistakes and rejections."
  },
  {
    question: "How much does trademark registration cost?",
    answer: "Our trademark registration services range from $45 to $349 depending on the package you choose, plus the USPTO government filing fee (currently $250-$350 per class of goods/services). The total cost depends on the number of classes you need to cover and the level of service you select. Our transparent pricing ensures you know exactly what you're paying for, with no hidden fees. We offer packages from basic filing services to comprehensive protection including trademark search, monitoring, and dedicated case management."
  },
  {
    question: "What is Amazon Brand Registry and do I need it?",
    answer: "Amazon Brand Registry is a program that helps brand owners protect their intellectual property and create an accurate, trusted experience for Amazon customers. To enroll, you need a registered trademark. Benefits include enhanced brand content capabilities (A+ Content), improved search and filtering tools, proactive brand protection including automated protections against suspected IP violations, and access to powerful tools to report violations. If you sell on Amazon, Brand Registry is essential for protecting your products and maximizing your brand's potential on the platform."
  },
  {
    question: "Can I trademark a logo and business name together?",
    answer: "Yes, you have several options: you can file separate applications for your word mark (business name) and design mark (logo), or file a combined mark that includes both elements together. Each approach has advantages - separate registrations provide broader protection as you can enforce each mark independently, while a combined mark may be more cost-effective. We analyze your specific needs and recommend the best trademark strategy to ensure comprehensive protection for your brand identity within your budget."
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+86", country: "China" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+34", country: "Spain" }
];

export const formSubmissions = [];
